import { NgModule } from "@angular/core";
import { Routes, RouterModule, ExtraOptions } from "@angular/router";

const routes: Routes =
	[
		// webapp
		{
			path: "",
			loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule)
		},

		// 404 page not found
		//----------------------------------------------------------
		{
			path: "**",
			redirectTo: "notfound"
		}
	];

const routerOptions: ExtraOptions =
{
	useHash: false,
	anchorScrolling: 'enabled',
	scrollPositionRestoration: 'enabled',
	bindToComponentInputs: true
};

@NgModule({
	imports:
		[
			RouterModule.forRoot(routes, routerOptions)
		],
	exports: [RouterModule]
})
export class AppRoutingModule { }
